/** Display size of enabler circles — Figma 192:163455 (~293.2px). */
export const ENABLER_CIRCLE_DISPLAY_SIZE = 293;

/** 2× photo pixel size for retina sharpness. */
export const ENABLER_CIRCLE_PHOTO_SIZE = 586;

/** SVG mask viewBox (Union export bounds). */
export const ENABLER_CIRCLE_MASK_VIEWBOX_WIDTH = 294;
export const ENABLER_CIRCLE_MASK_VIEWBOX_HEIGHT = 286;

const ENABLER_CIRCLE_MASK_DIR = '/svg/enabler-circle-masks';
const ENABLER_CIRCLE_PHOTO_DIR = '/media/enabler-circles';

export const ENABLER_CIRCLE_IDS = [
  'coordinate-action-along-flyways',
  'influence-policy-and-legislation',
  'mobilise-finance-for-flyways',
  'empower-indigenous-peoples-and-local-communities',
  'strengthen-capacity-and-raise-awareness',
  'monitor-bird-populations',
] as const;

export type EnablerCircleId = (typeof ENABLER_CIRCLE_IDS)[number];

/** Asset stem per overlay entry id (filename without extension). */
export const ENABLER_CIRCLE_ASSET_STEM: Record<EnablerCircleId, string> = {
  'coordinate-action-along-flyways': 'coordinate-action',
  'influence-policy-and-legislation': 'influence-policy',
  'mobilise-finance-for-flyways': 'mobilise-finance',
  'empower-indigenous-peoples-and-local-communities': 'empower-communities',
  'strengthen-capacity-and-raise-awareness': 'strengthen-capacity',
  'monitor-bird-populations': 'monitor-bird-populations',
};

export function enablerCirclePhotoSrc(id: EnablerCircleId): string {
  return `${ENABLER_CIRCLE_PHOTO_DIR}/${ENABLER_CIRCLE_ASSET_STEM[id]}.jpg`;
}

export function enablerCircleMaskSrc(id: EnablerCircleId): string {
  return `${ENABLER_CIRCLE_MASK_DIR}/${ENABLER_CIRCLE_ASSET_STEM[id]}.svg`;
}
